import React, { useState } from 'react'
import OnboardingTasksDrawer from '../components/OnboardingTasksDrawer'
import FileUpload from 'core-system/FileUpload/FileUpload'
import Text from 'core-system/Text'
import { uploadAdditionalDocuments } from 'features/Onboarding/onboardingService'
import { onboardingActions } from 'features/Onboarding/onboardingActions'
import { useDispatch } from 'react-redux'

interface AdditionalInformationDrawerProps {
  isOpen: boolean
  onClose: () => void
}

const AdditionalInformationDrawer = (
  props: AdditionalInformationDrawerProps
) => {
  const { isOpen, onClose } = props
  const [file, setFile] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch()
  const uploadReceiptToServer = async (files: File[]) => {
    setIsLoading(true)
    const response = await uploadAdditionalDocuments(files[0])
    if (response.status === 'success') {
      setFile([
        {
          name: 'Receipt',
          downloadUrl: response.downloadUrl,
          type: files[0].type,
        },
      ])
    }
    setIsLoading(false)
  }

  return (
    <OnboardingTasksDrawer
      isOpen={isOpen}
      onClose={onClose}
      primaryButton={{
        text: 'Submit',
        onClick: () => {
          dispatch(
            onboardingActions.updateOnboardingSectionStatus({
              sectionType: 'ADDITIONAL_DETAILS',
              status: 'COMPLETED',
            })
          )
          onClose()
        },
        disabled: false,
        loading: isLoading,
      }}
    >
      <Text variant='h3' marginBottom='2rem'>
        Additional Information
      </Text>
      <Text variant='action4' marginBottom='1rem'>
        Please upload the additional documents here*
      </Text>
      <FileUpload
        placeholder='Upload your documents here'
        acceptedFilesTypes={['.png', '.jpeg', '.pdf']}
        placeholderSubtitle='PDF, JPG, PNG'
        onChange={setFile}
        files={file}
        uploadFiles={uploadReceiptToServer}
      />
    </OnboardingTasksDrawer>
  )
}

export default AdditionalInformationDrawer
